import React, { useEffect, useRef, useState } from 'react'
import api from '../../../api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from "primereact/toast";


const Measure_2 = () => {
      const userID = sessionStorage.getItem("UserID");
      const currentDate1 = new Date();
      const toast = useRef(null);

      const formattedCurrentDate = `${currentDate1.getDate().toString().padStart(2, '0')}-${(currentDate1.getMonth() + 1).toString().padStart(2, '0')}-${currentDate1.getFullYear()} ${currentDate1.getHours().toString().padStart(2, '0')}:${currentDate1.getMinutes().toString().padStart(2, '0')}:${currentDate1.getSeconds().toString().padStart(2, '0')}`;
      const dt = useRef(null);
      const [loading, setLoading] = useState(false);
  
      const [data, setData] = useState([]);
      const getDemographicRawData = async () => {
        try {
          setLoading(true);

          const requestData = {
            logged_in_userid: userID,
            table_name:"trn_tbl_baseline_pss",
            synceddatetime: formattedCurrentDate,
            FormCode: "202",
            ApiKey: "kavin",
            AppTypeNo: "3",
            AppVersion: "1.0.0",
            data_source: "W"
          };
    
        const result = await api.get_Raw_Data(requestData);
        const responseData = result.trn_tbl_baseline_pss;
        const slNo = responseData.map((item, index) => ({
                   ...item, slno: index + 1
              }));
        setData(slNo);
        } catch (error) {
          console.error("Error fetching state:", error);
        toast.current.show({
          severity: "info",
          summary: "No Data Found",
          detail: "There is no data for this table"
      });
        } finally {
          setLoading(false);
        }
      };
    
      useEffect(() => {
        getDemographicRawData();
      }, []);

      const cleanValue = (value) => {
        if (value === "-999" || value === -999) return "";

        if (typeof value === "string" && value.includes("$")) {
          return value.split("$").join(",");
        }

        return value;
      };

    const exportData = data.map(item => ({
        "SlNo": item.slno,
        "Sate" : cleanValue(item.fld_state_name),
        "District" : cleanValue(item.fld_district_name),
        "Site" : cleanValue(item.fld_site_name),
        "Taluk" : cleanValue(item.fld_taluk_name),
        "Village" : cleanValue(item.fld_village_name),
        "PHC" : cleanValue(item.fld_phc_name),
        "PHC Type" : cleanValue(item.fld_phc_type_name),
        "PRS name" : cleanValue(item.fld_prs_name),
        // "Participant registration date" : cleanValue(item.fld_participant_registration_date),
        "Participant Name" : cleanValue(item.fld_participant_name),
        "Participant ID" : cleanValue(item.fld_participant_id),
        "PSS done Date": cleanValue(item.fld_pss_done_date),
        "In the last month, how often have you been upset because of something that happened unexpectedly": cleanValue(item.fld_how_often_get_upset_name),
        "In the last month, how often have you felt that you were unable to control the important things in your life?": cleanValue(item.fld_how_often_unable_control_imp_thing_name),
        "In the last month, how often have you felt nervous and stressed?":cleanValue(item.fld_how_often_felt_nervous_and_stressed_name),
        "In the last month, how often have you felt confident about your ability to handle your personal problems?":cleanValue(item.fld_how_offten_felt_confident_handle_personal_problem_name),
        "In the last month, how often have you felt that things were going your way":cleanValue(item.fld_how_often_felt_things_were_going_your_way_name),
        "In the last month, how often have you found that you could not cope with all the things that you had to do?":cleanValue(item.fld_how_often_found_not_cope_with_all_things_name),
        "In the last month, how often have you been able to control irritations in your life?":cleanValue(item.fld_how_often_able_to_control_irritations_name),
        "In the last month, how often have you felt that you were on top of things?":cleanValue(item.fld_how_often_you_felt_you_were_on_top_thing_name),
        "In the last month, how often have you been angered because of things that happened that were outside of your control?":cleanValue(item.fld_how_often_angered_because_things_happend_outside_name),
        "In the last month, how often have you felt difficulties were piling up so high that you could not overcome them?":cleanValue(item.fld_how_often_felt_difficulties_were_piling_up_name),
        "Total score":cleanValue(item.fld_pss_total_score),
        "Loggedin User ID": cleanValue(item.fld_loggedin_user_id),
        "System Inserted Date": item.fld_system_inserted_datetime
          ? new Date(item.fld_system_inserted_datetime).toISOString().split("T")[0]
          : "", // fallback in case value is missing
    }));

      const handleDownloadCSV = () => {
          if (!data || data.length === 0) {
            console.warn("No data available to export");
            return;
          }

          // Convert JSON to worksheet
          const worksheet = XLSX.utils.json_to_sheet(exportData);

          // Create a new workbook and append the worksheet
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, `Measure_of_Stress_Data`);

          // Generate buffer
          const excelBuffer = XLSX.write(workbook, {
            bookType: "csv",
            type: "array"
          });

          // Create Blob and trigger download
          const dataBlob = new Blob([excelBuffer], { type: "text/csv;charset=utf-8;" });
          saveAs(dataBlob, "Measure_of_Stress_Data.csv");
        };


  return (
    <div>
        <Toast ref={toast} position="top-right" />
        {loading && (
            <div className="backdrop">
                <ProgressSpinner style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
            </div>
        )}
        <span className='flex justify-content-end mt-2 mb-4'>
            <Button className="downloadbutton"
                label='Download CSV'
                icon="pi pi-download"
                onClick={handleDownloadCSV}
            />
        </span>
            <DataTable
              value={data}
              scrollHeight="350px"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              ref={dt}
              scrollable
            >
              <Column field="slno" header="Sl.No" />
              <Column field="fld_phc_name" header="PHC Name" />
              <Column field="fld_loggedin_user_id" header="User ID" />
              <Column field="fld_participant_name" header="Participent Name"></Column>
              <Column field="fld_participant_id" header="Participent ID"></Column>
              <Column field="fld_pss_done_date" header="PSS Done Date"></Column>
              <Column field="fld_how_often_get_upset_name" header="Q 1"></Column>
              <Column field="fld_how_often_unable_control_imp_thing_name" header="Q 2"></Column>
              <Column field="fld_how_often_felt_nervous_and_stressed_name" header="Q 3"></Column>
              <Column field="fld_how_offten_felt_confident_handle_personal_problem_name" header="Q 4"></Column>
              <Column field="fld_how_often_felt_things_were_going_your_way_name" header="Q 5"></Column>
              <Column field="fld_how_often_found_not_cope_with_all_things_name" header="Q 6"></Column>
              <Column field="fld_how_often_able_to_control_irritations_name" header="Q 7"></Column>
              <Column field="fld_how_often_you_felt_you_were_on_top_thing_name" header="Q 8"></Column>
              <Column field="fld_how_often_angered_because_things_happend_outside_name" header="Q 9"></Column>
              <Column field="fld_how_often_felt_difficulties_were_piling_up_name" header="Q 10"></Column>
              <Column field="fld_pss_total_score" header="PSS Total Score"></Column>

            </DataTable>
    </div>
  )
}

export default Measure_2